export default __webpack_public_path__ + "static/media/subscription_appendix_low.45a39ba1.jpg";